import useInterval from 'hooks/useInterval';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  getAttendeeStatusAction,
  getCachedQuestionsAction,
} from 'store/conference/conferenceActions';
import VideoWrapper from '../components/videoWrapper';
import ConferenceStyleWrapper from '../conference-wrapper/ConferenceWrapper';

export default function Index() {
  const dispatch = useDispatch();
  const { isRecordingUser } = useSelector(({ user }) => ({
    user: user.isRecordingUser,
  }));
  useInterval(async () => {
    dispatch(getAttendeeStatusAction());
  }, 20000);
  useInterval(async () => {
    if (!isRecordingUser) {
      dispatch(getCachedQuestionsAction());
    }
  }, 10000);

  return (
    <ConferenceStyleWrapper>
      <VideoWrapper isAttendee={true} />
    </ConferenceStyleWrapper>
  );
}
